import urls from "@src/configs/web.config";
import { getAppTypeFromPath } from '../../utils/common'
/**
 *
 * @param {*} limit
 * @param {*} offset
 */
export const getSolutionsList = async (limit, offset) => {
  try {
    const res = await fetch(
      `${urls.solutionsUrl}?pageNum=${limit}&pageSize=${offset}`,
      { method: "GET" }
    );
    return res && res.data ? res.data : null;
  } catch (error) {
    return null;
  }
};

export const deleteSolutions = async solutionId => {
  try {
    const result = await fetch(urls.solutionsUrl, {
      method: "DELETE",
      body: [...solutionId]
    });
    return result ? result : null;
  } catch (error) {
    return null;
  }
};

/**
 * @description 查询应用详情
 * @param {string} appId
 * @param {'innerapp'|'isv'} type innerapp-0:自建应用，isv-2:第三方应用
 */
export const getAppInfoList = async (appId, type) => {
  try {
    const appInfoUrl = {
      innerapp: "innerapp",
      isv: "isv/app"
    };
    let url = `/${process.env.REACT_APP_API_CONTEXT}/service/${appInfoUrl[type]}/${appId}`;
    return await fetch(url, { method: "GET" });
  } catch (error) {
    return null;
  }
};

/**
 * @description 是否有新版本
 * @param {string} appId
 * @param {'innerapp'|'isv'} type innerapp-0:自建应用，isv-2:第三方应用
 */
export const getHasNewVersion = async (appId, type) => {
  try {
    let url = `/${process.env.REACT_APP_API_CONTEXT}/service/innerapp/version/compare?appId=${appId}&appType=${type}`;
    const res = await fetch(url, { method: "GET" });
    return res;
  } catch (error) {
    return null;
  }
};
